import { useMutation, useQuery } from 'react-query';
import * as productSuggestionService from '../services/productSuggestionService';
import { ListProductSuggestionsDto } from 'types/dto/ListProductSuggestionsDto';

export const useSuggestProduct = (onSuccess: any, onError: any) => {
  return useMutation(productSuggestionService.suggestProduct, {
    onSuccess,
    onError
  });
}

export const useGetProductSuggestions = (
  dto: ListProductSuggestionsDto,
  options = {}
) => {
  return useQuery({
    queryKey: ['productSuggestions', dto],
    queryFn: () => productSuggestionService.getProductSuggestions(dto),
    keepPreviousData: true,
    ...options
  });
}


export const useGetProductSuggestionById = (
  suggestionId: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['productSuggestion', suggestionId],
    queryFn: () => productSuggestionService.getProductSuggestionById(suggestionId),
    ...options
  });
}

export const useArchiveProductSuggestion = (onSuccess: any, onError: any) => {
  return useMutation(productSuggestionService.archiveProductSuggestion, {
    onSuccess,
    onError
  });
}

export const useDeleteProductSuggestion = (onSuccess: any, onError: any) => {
  return useMutation(productSuggestionService.deleteProductSuggestion, {
    onSuccess,
    onError
  });
}

export const useRestoreProductSuggestion = (onSuccess: any, onError: any) => {
  return useMutation(productSuggestionService.restoreProductSuggestion, {
    onSuccess,
    onError
  });
}

export const usePermanentlyDeleteProductSuggestion = (onSuccess: any, onError: any) => {
  return useMutation(productSuggestionService.permanentlyDeleteProductSuggestion, {
    onSuccess,
    onError
  });
}
